import React, { useState } from "react";
import "./Login.css";
import Logo from "../../assets/appImages/logo.png";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { NavLink } from "react-router-dom";
import { UseResetPasswordForm } from "./requestForm/UseResetPasswordForm";
import { FormError } from "../common/Input";
import { PasswordRules } from "./PasswordRules";

const ResetPassword = () => {
  const {
    register,
    errors,
    onSubmit,
    isLoading,
    haveMinCharacter,
    haveMinLowercase,
    haveMinNumber,
    haveMinSpecialCharacter,
    haveMinUppercase,
    passwordHandleChange,
  } = UseResetPasswordForm();
  const props = {
    haveMinCharacter,
    haveMinNumber,
    haveMinLowercase,
    haveMinSpecialCharacter,
    haveMinUppercase,
  };
  const [showPassword, setShowPassword] = useState(false);
  return (
    <div>
      <div className="empty-header-auth">
        <div className="content-img-logo-login-app">
          <img src={Logo} alt="Logo" className="img-logo-login-app" />
        </div>
      </div>
      <div className="container-page-login-app">
        <div className="auth-row">
          <div className="auth-col auth-right-side-col">
            <div className="auth-right-side-container">
              <div className="auth-form-container text-center pb-4">
                <h2 className="title-auth-form-text pt-5">
                  Réinitialisation mot de passe
                </h2>
                <div className="mt-5">
                  <form id="auth-form" onSubmit={onSubmit}>
                    <div className="row auth-form-row">
                      {/* <div className="col-md-12 auth-input-col mb-3">
                        <div className="auth-form-group">
                          <label className="form-label form-label-auth-login">
                            Adresse email
                          </label>
                          <input
                            type={`email`}
                            className="form-control auth-form-control"
                            id="email-or-username"
                            aria-label="Username"
                            placeholder="Email"
                            {...register("email")}
                          />
                          <FormError error={errors?.email?.message} />
                        </div>
                      </div> */}
                      <div className="col-md-12 auth-input-col mb-3">
                        <div className="auth-form-group">
                          <label className="form-label form-label-auth-login">
                            Code
                          </label>
                          <input
                            type={`text`}
                            className="form-control auth-form-control"
                            id="code-or-username"
                            aria-label="Username"
                            placeholder="Code"
                            {...register("code")}
                          />
                          <FormError error={errors?.code?.message} />
                        </div>
                      </div>
                      <div className="col-md-12 auth-input-col mb-2">
                        <div className="auth-form-group position-relative">
                          <label className="form-label form-label-auth-login">
                            Nouveau mot de passe
                          </label>
                          <input
                            type={showPassword ? "text" : "password"}
                            className="form-control auth-form-control"
                            id="new_password"
                            placeholder="Mot de passe"
                            aria-label="Password"
                            aria-placeholder="***********"
                            name="new_password"
                            onChange={passwordHandleChange}
                          />
                          <span
                            className="show-hide-password"
                            onClick={() => {
                              setShowPassword(!showPassword);
                            }}
                          >
                            {showPassword ? (
                              <AiFillEyeInvisible />
                            ) : (
                              <AiFillEye />
                            )}
                          </span>
                          <FormError error={errors?.new_password?.message} />
                        </div>
                      </div>
                      <PasswordRules {...props} />
                      <div className="col-md-12 auth-input-col mb-2">
                        <div className="auth-form-group position-relative">
                          <label className="form-label form-label-auth-login">
                            Confirmer mot de passe
                          </label>
                          <input
                            type={showPassword ? "text" : "password"}
                            className="form-control auth-form-control"
                            id="new_password_confirm"
                            placeholder="Mot de passe"
                            aria-label="Password"
                            aria-placeholder="***********"
                            {...register("new_password_confirm")}
                          />
                          {/* <span
                            className="show-hide-password"
                            onClick={() => {
                              setShowPassword(!showPassword);
                            }}
                          >
                            {showPassword ? (
                              <AiFillEyeInvisible />
                            ) : (
                              <AiFillEye />
                            )}
                          </span> */}
                          <FormError
                            error={errors?.new_password_confirm?.message}
                          />
                        </div>
                      </div>
                      <div className="col-md-12 auth-submit-btn-container mt-5">
                        <button
                        type="submit"
                          className="btn auth-submit-btn trans-0-2"
                          disabled={isLoading}
                        >
                          {!isLoading ? (
                            `Envoyer`
                          ) : (
                            <>
                              <span
                                className="spinner-border spinner-border-sm text-light me-1 d-inline-block"
                                role="status"
                              ></span>
                              <span>Chargement...</span>
                            </>
                          )}
                        </button>
                      </div>
                      <div className="col-md-12 mt-3 text-right">
                        <span className="mt-2">
                          <NavLink
                            className="nav-link forget-password-link"
                            to="/"
                            data-tooltip-content="Gestionnaires"
                          >
                            Se connecter
                          </NavLink>
                        </span>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
